import { useState } from "react";

import { InputAccessModal } from "@/components/common/modals/input-access-modal";

import { ContextMenuItem } from "@/components/ui/context-menu";

const Access: React.FC<
  React.ComponentProps<"div"> & {
    rightClickedElement: HTMLElement;
  }
> = ({ rightClickedElement }) => {
  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);

  const accessTarget =
    (rightClickedElement.closest("[contenteditable='false']") as HTMLElement | null) ??
    rightClickedElement.parentElement ??
    rightClickedElement;

  const inputId = accessTarget?.id ?? "";

  return (
    <>
      <ContextMenuItem
        className="flex items-center justify-between"
        onSelect={(event) => {
          event.preventDefault();

          if (!accessTarget) return;

          setIsAccessModalOpen(true);
        }}
      >
        دسترسی
      </ContextMenuItem>

      <InputAccessModal
        isOpen={isAccessModalOpen}
        inputId={inputId}
        input={accessTarget}
        title="مدیریت دسترسی آیکون"
        onClose={() => setIsAccessModalOpen(false)}
      />
    </>
  );
};

export default Access;